import { render } from "./SottoProgettiMenu.vue?vue&type=template&id=a299e6ca&ts=true"
import script from "./SottoProgettiMenu.vue?vue&type=script&lang=ts"
export * from "./SottoProgettiMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__